import { useContext } from "react";
import { InputLabel, MenuItem, FormControl, Select } from "@mui/material";
import { MessengerContext } from "../../../contexts/MessengerContext";

const RecipientFilters = () => {
  const { recipientFilter, setRecipientFilter } = useContext(MessengerContext);


  const handleChange = (e) => {
    setRecipientFilter(e.target.value);
  };

  return (
    <FormControl style={{ width: 300 }} size="small">
      <InputLabel id="label">Filter</InputLabel>
      <Select
        labelId="label"
        value={recipientFilter || ""}
        label="Recipients"
        onChange={handleChange}
      >
        <MenuItem value="all">All Attendees</MenuItem>
        <MenuItem value="incompleteProfile">Incomplete Profiles</MenuItem>
        <MenuItem value="checkedIn">Checked In Attendees</MenuItem>
        <MenuItem value="notCheckedIn">Not Checked In</MenuItem>
        <MenuItem value="matched">Have Matches</MenuItem>
        <MenuItem value="noMatches">No Matches</MenuItem>
        <MenuItem value="custom">Custom</MenuItem>
      </Select>
    </FormControl>
  );
};

export default RecipientFilters;
